import { MarkovTransition } from "server/models"
import { OrderType } from "client/utils"

export interface MarkovTransitionProps {
    transitionId: number
}

export type MarkovTransitionValidation = { [key in keyof MarkovTransition]?: string}

export interface MarkovTransitionList { [transitionId: number]: MarkovTransition }
export interface MarkovTransitionCalculated { [transitionId: number]: number | string }

export interface MarkovTransitionState {
    transitionList: MarkovTransitionList
    transitionIds: readonly number[]
    transitionEdit: MarkovTransition

    calculatedExpressions: MarkovTransitionCalculated

    sortColumn: keyof MarkovTransition
    sortOrder: OrderType

    reloadList: boolean
    reloadEdit: boolean
}

export const MARKOV_TRANSITION_LIST = "MARKOV_TRANSITION_LIST"
export const MARKOV_TRANSITION_IDS = "MARKOV_TRANSITION_IDS"
export const MARKOV_TRANSITION_EDIT = "MARKOV_TRANSITION_EDIT"

export const MARKOV_TRANSITION_CALCULATED_EXPRESSIONS = "MARKOV_TRANSITION_CALCULATED_EXPRESSIONS"

export const MARKOV_TRANSITION_SORT = "MARKOV_TRANSITION_SORT"

export const MARKOV_TRANSITION_RELOAD_LIST = "MARKOV_TRANSITION_RELOAD_LIST"
export const MARKOV_TRANSITION_RELOAD_EDIT = "MARKOV_TRANSITION_RELOAD_EDIT"
